

import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ServiceCard } from "@/components/services/ServiceCard";
import { Wrench, Bolt, AirVent, Home, Paintbrush, TreeDeciduous, SprayCan, Building2, HardHat, Hammer } from "lucide-react";

const services = [
  {
    title: "Plumbing Services",
    description: "Expert plumbing solutions for residential and commercial properties. From repairs to installations, we've got you covered.",
    icon: Wrench,
    link: "/best-plumbers-oklahoma-city"
  },
  {
    title: "Electrical Services",
    description: "Licensed electricians providing comprehensive electrical services. Safety and quality are our top priorities.",
    icon: Bolt,
    link: "/best-electricians-oklahoma-city"
  },
  {
    title: "HVAC Services",
    description: "Complete heating, ventilation, and air conditioning services. Keep your space comfortable all year round.",
    icon: AirVent,
    link: "/best-hvac-contractors-oklahoma-city"
  },
  {
    title: "Roofing Services",
    description: "Professional roofing installation, repair, and maintenance services. Protect your property with our experienced roofing contractors.",
    icon: Home,
    link: "/best-roofers-oklahoma-city"
  },
  {
    title: "General Contracting",
    description: "Comprehensive construction and renovation services for your home or business. Quality craftsmanship from start to finish.",
    icon: HardHat,
    link: "/best-general-contractors-oklahoma-city"
  },
  {
    title: "House Cleaning",
    description: "Professional house cleaning services to keep your home spotless. Regular cleaning, deep cleaning, and move-in/move-out services.",
    icon: Building2,
    link: "/house-cleaning-services-oklahoma-city"
  },
  {
    title: "Pest Control",
    description: "Effective pest control solutions to protect your property. Professional exterminators handling all types of pest problems.",
    icon: SprayCan,
    link: "/pest-control-services-oklahoma-city"
  },
  {
    title: "Painting Services",
    description: "Expert interior and exterior painting services. Transform your space with our professional painting contractors.",
    icon: Paintbrush,
    link: "/painting-contractors-oklahoma-city"
  },
  {
    title: "Tree Services",
    description: "Complete tree care solutions including trimming, removal, and maintenance. Professional arborists serving OKC.",
    icon: TreeDeciduous,
    link: "/best-tree-services-okc"
  },
  {
    title: "Landscaping",
    description: "Professional landscaping services to enhance your outdoor space. Design, installation, and maintenance services.",
    icon: Building2,
    link: "/landscaping-services-oklahoma-city"
  },
  {
    title: "Restoration Services",
    description: "Expert restoration services for water, fire, and storm damage. 24/7 emergency response available.",
    icon: Hammer,
    link: "/best-restoration-contractors-okc"
  }
];

const FeaturedServices = () => {
  console.log('Rendering FeaturedServices page');
  
  return (
    <>
      <SEO 
        title="Home Services in Oklahoma City | Home Pros OKC"
        description="Discover our comprehensive home services in Oklahoma City. From plumbing and electrical to HVAC and roofing, find trusted professionals for your needs."
      />
      
      <div className="container mx-auto px-4 py-8">
        <Breadcrumbs items={[{ label: "Services" }]} />
        
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-4">Our Services</h1>
          <p className="text-lg text-muted-foreground text-center mb-12">
            Connect with trusted professionals for all your home service needs in Oklahoma City
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <ServiceCard key={service.title} {...service} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturedServices;

